import { useState } from 'react';
import type { FormEvent } from 'react';
import type { TypeInteraction } from '@cockpit/shared';
import { TypesInteraction } from '@cockpit/shared';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';

interface Props {
  defaultType?: TypeInteraction;
  defaultDate?: string; // YYYY-MM-DD
  submitting?: boolean;
  onSubmit: (data: {
    type_interaction: TypeInteraction;
    date_interaction: string; // ISO UTC
    resume: string;
    prochaine_etape: string | null;
  }) => void;
  onCancel?: () => void;
}

function todayLocalDate(): string {
  return new Date().toISOString().slice(0, 10);
}

export function InteractionForm({
  defaultType = 'Appel',
  defaultDate,
  submitting,
  onSubmit,
  onCancel,
}: Props): JSX.Element {
  const [type, setType] = useState<TypeInteraction>(defaultType);
  const [date, setDate] = useState(defaultDate ?? todayLocalDate());
  const [resume, setResume] = useState('');
  const [prochaineEtape, setProchaineEtape] = useState('');

  const handle = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (resume.trim() === '') return;
    onSubmit({
      type_interaction: type,
      date_interaction: `${date}T00:00:00.000Z`,
      resume: resume.trim(),
      prochaine_etape: prochaineEtape.trim() === '' ? null : prochaineEtape.trim(),
    });
    setResume('');
    setProchaineEtape('');
  };

  return (
    <form
      onSubmit={handle}
      className="bg-slate-900/40 border border-slate-800 rounded-xl p-4 flex flex-col gap-3"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Select
          label="Type"
          value={type}
          onChange={(e): void => setType(e.target.value as TypeInteraction)}
          options={TypesInteraction.map((t) => ({ value: t, label: t }))}
        />
        <Input
          label="Date"
          type="date"
          value={date}
          onChange={(e): void => setDate(e.target.value)}
        />
      </div>
      <div>
        <label className="text-xs font-medium text-slate-300">Résumé *</label>
        <textarea
          value={resume}
          onChange={(e): void => setResume(e.target.value)}
          rows={2}
          required
          className="mt-1 w-full bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 focus:border-floryon-green focus:outline-none focus:ring-1 focus:ring-floryon-green/50"
        />
      </div>
      <Input
        label="Prochaine étape (optionnel)"
        value={prochaineEtape}
        onChange={(e): void => setProchaineEtape(e.target.value)}
      />
      <div className="flex justify-end gap-2">
        {onCancel !== undefined && (
          <Button type="button" variant="secondary" size="sm" onClick={onCancel}>
            Annuler
          </Button>
        )}
        <Button type="submit" size="sm" disabled={submitting === true}>
          {submitting === true ? 'Enregistrement…' : 'Ajouter'}
        </Button>
      </div>
    </form>
  );
}
